import { Scripts, ScrollRestoration, useLoaderData, useLocation } from 'react-router';
import { GoogleTagManagerBody } from '@cx-web/components/third-party/google-tag-manager';
import { featureFlags, useFeatureFlag } from '@cx-web/feature-flags/provider';
import { ExternalScripts } from 'remix-utils/external-scripts';

import { PageProvider } from '~/providers/page-context';

import { type loader } from './loader.server';
import PageTemplateImpl from './route-impl';

export default function Body() {
  const rootLoaderData = useLoaderData<typeof loader>();
  if (!rootLoaderData) {
    throw new Error('Root loader data is missing');
  }

  const { pathname } = useLocation();
  const disableGtm = useFeatureFlag(featureFlags.DISABLE_GOOGLE_TAG_MANAGER);
  const disableOffersWidgets = useFeatureFlag(featureFlags.DISABLE_OFFER_WIDGETS);

  const { ENV, currentPathWithRepub, deviceType, gtmId, url } = rootLoaderData;

  return (
    <body data-fpsm-theme="oddschecker" data-template={pathname.split('/').slice(1).join('_')}>
      <GoogleTagManagerBody
        gtmId={gtmId}
        shouldRender={!disableGtm && (ENV.ENVIRONMENT === 'PROD' || ENV.ENVIRONMENT === 'STG')}
      />
      <PageProvider
        ENV={ENV}
        currentPathWithRepub={currentPathWithRepub}
        deviceType={deviceType}
        fullPageUrl={url}
        gtmId={gtmId}
      >
        <PageTemplateImpl />
      </PageProvider>
      <script
        dangerouslySetInnerHTML={{
          __html: `window.ENV = ${JSON.stringify(ENV)}`,
        }}
      />
      <ScrollRestoration />
      {!disableOffersWidgets && <ExternalScripts />}
      <Scripts />
    </body>
  );
}
